import React from "react";
import Layout from "../Layout";
import ScriptTemplateEditorPage from "../../ScriptTemplateEditorPage";

const ScriptTemplateEditor = () => {
  return (
    <Layout>
      <ScriptTemplateEditorPage />
    </Layout>
  );
};

export default ScriptTemplateEditor;
